// FIXME: WalletConnect's v1 SDKs are now deprecated. Please upgrade to a v2 SDK. For details see: https://docs.walletconnect.com/ | https://www.npmjs.com/package/@walletconnect/web3-provider
import WalletConnectProvider from '@walletconnect/web3-provider'
import CoinbaseWalletSDK from '@coinbase/wallet-sdk'
// import Fortmatic from 'fortmatic'
// import { Portis } from '@portis/web3'
// import { sequence } from '0xsequence'
// import ethProvider from 'eth-provider'
// import { Bitski } from 'bitski'

// import Torus from '@toruslabs/torus-embed'
// import { Venly } from '@venly/web3-provider'

// const chainId = 137 // Polygin mainnet
// const rpcUrl = 'https://polygon-rpc.com/'

const chainId = 137 // Polygin edge
const rpcUrl = 'https://polygon-rpc.com'
// const rpcUrl = 'https://rpc.api.moonbeam.network'

const appName = 'Midnight Society'
// const callbackUrl = 'https://midnightsociety.com/'

// const customNetworkOptions = {
//   rpcUrl: rpcUrl,
//   chainId: chainId,
// }

// const customNetwork_Portis = {
//   nodeUrl: rpcUrl,
//   chainId: chainId,
// }

export const initProviderOptions = () => {
  return {
    walletlink: {
      package: CoinbaseWalletSDK, // Required
      options: {
        appName: appName, // Required
        // infuraId: 'e51f18f06e6241e9a7a1118f47969ceb', // Required unless you provide a JSON RPC url; see `rpc` below
        rpc: rpcUrl, // optional
        chainId: chainId, // Optional. It defaults to 1 if not provided
        darkMode: false, // Optional. Use dark theme, defaults to false
      },
    },
    walletconnect: {
      package: WalletConnectProvider, // required
      options: {
        // infuraId: 'e51f18f06e6241e9a7a1118f47969ceb', // Only use when this one is a paid key (Infura is not free for Polygon)
        rpc: {
          137: 'https://polygon-rpc.com',
        },
        // network: 'mainnet',
        chainId: 137,
      },
    },

    // fortmatic: {
    //   package: Fortmatic,
    //   options: {
    //     key: 'pk_test_391E26A3B43A3350', // TODO: change to production key
    //     network: customNetworkOptions,
    //   },
    // },

    // torus: {
    //   package: Torus, // required
    //   options: {
    //     networkParams: {
    //       host: rpcUrl,
    //       chainId: chainId,
    //     },
    //     config: {
    //       enableLogging: true, // optional
    //       // buttonPosition: "bottom-left", // optional
    //       // buildEnv: "production", // optional
    //       // showTorusButton: true, // optional
    //     },
    //     enabledVerifiers: {
    //       google: true, // optional
    //     },
    //   },
    // },

    // portis: {
    //   package: Portis, // required
    //   options: {
    //     id: '5d2986e9-96d9-4d17-91f8-de1bbf7922ef', // TODO: change to production id
    //     network: customNetwork_Portis,
    //   },
    // },

    // venly: {
    //   package: Venly, // required
    //   options: {
    //     clientId: 'Testaccount', // TODO: replace to a business account
    //     environment: 'qa', // TODO: replace to 'prod' (as production)
    //     secretType: 'MATIC',
    //   },
    // },

    /* New sign-ups have been turned off
    authereum: {
      package: Authereum, // required
      options: {
      }
    }, */

    /* This wallet is only active when there is no any other web3 injected providers (Metamask/Brave) enabled */
    clvwallet: {
      package: true,
    },

    /* This wallet does not support Polygon
    boltx: {
      package: true,
    },*/

    /* This wallet does not support Polygon
    binancechainwallet: {
      package: true,
    }, */

    // sequence: {
    //   package: sequence, // required
    //   options: {
    //     appName: appName,
    //     defaultNetwork: 'polygon', // optional
    //   },
    // },

    // bitski: {
    //   package: Bitski, // required - @bitski/provider-engine
    //   options: {
    //     clientId: 'a65bf0e2-faa4-4c4f-a3dc-cc7a796bcd15', // TODO: change to business ID
    //     callbackUrl: callbackUrl,
    //     network: customNetworkOptions,
    //   },
    // },

    // frame: {
    //   package: ethProvider, // required
    // },

    // mewconnect: {
    //   package: require('@myetherwallet/mewconnect-web-client').default, // required
    //   options: {
    //     infuraId: 'e51f18f06e6241e9a7a1118f47969ceb',
    //   },
    // },
  }
}
